import { useEffect, useState } from 'react';
import { useParamsStore } from '@/stores/paramsStore.js';
import { debouncedGenerate } from '@/lib/noise-client.js';
import type { Heightmap } from '@wg/noise';

export function useHeightmap(): { heightmap: Heightmap | null; generating: boolean; version: number } {
  const params = useParamsStore((s) => s.params);
  const [heightmap, setHeightmap] = useState<Heightmap | null>(null);
  const [generating, setGenerating] = useState(false);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    setGenerating(true);
    let cancelled = false;
    debouncedGenerate(params)
      .then((h) => { if (!cancelled) { setHeightmap(h); setVersion((v) => v + 1); } })
      .catch((e) => { if (!cancelled) console.error('[noise] generate failed', e); })
      .finally(() => { if (!cancelled) setGenerating(false); });
    return () => { cancelled = true; };
  }, [params]);

  return { heightmap, generating, version };
}
